<template>
    <div class="mx-auto flex flex-grow flex-col">

        <div class="flex">

            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 flex flex-grow pt-12">


                <main class="mx-auto w-full pb-10">


                    <!-- Plan switch -->
                    <div class="flex items-center justify-center space-x-4">
                      <span class="text-base font-medium cursor-pointer"
                        v-bind:class="{'text-gray-600':billPlan != 'monthly'}"
                        @click="billPlan = 'monthly'">Bill Monthly</span>
                      <button
                              class="relative rounded-full focus:outline-none"
                              x-cloak
                              @click="billPlan == 'monthly' ? billPlan = 'yearly' : billPlan = 'monthly'"
                              >
                        <div class="w-16 h-8 transition bg-blue-500 rounded-full shadow-md outline-none"></div>
                        <div
                             class="absolute inline-flex items-center justify-center w-6 h-6 transition-all duration-200 ease-in-out transform bg-white rounded-full shadow-sm top-1 left-1"
                             :class="{ 'translate-x-0': billPlan == 'monthly', 'translate-x-8': billPlan == 'yearly' }"
                             ></div>
                      </button>
                      <span class="text-base font-medium cursor-pointer"
                        v-bind:class="{'text-gray-600':billPlan != 'yearly'}"
                        @click="billPlan = 'yearly'">Bill Annually</span>
                    </div>




                <table border="0" class="mx-auto w-full max-w-5xl mt-8">
                    <thead>
                    <!-- <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th class="text-green-500 pb-5 flex flex-row justify-center items-center">
                            <vue-feather v-if="!is_subscribed" type="check" class="h-4 w-4 mr-2" />
                            <span v-if="!is_subscribed">Current plan</span></th>
                        <th></th>
                        <th class="text-green-500 pb-5 flex flex-row justify-center items-center">
                            <vue-feather v-if="is_subscribed" type="check" class="h-4 w-4 mr-2" />
                            <span v-if="is_subscribed">Current plan</span></th>
                        <th></th>
                    </tr> -->
                    <tr>
                        <th class="pspacer"></th>
                        <th class="plabel p-5 text-left align-bottom">Features</th>
                        <th class="pspacer"></th>
                        <th class="pcol p-5 bg-white rounded-t-md text-left">

                            <div class="flex-shrink-0 mt-5">
                                <span
                                      class="text-4xl font-medium tracking-tight"
                                      :class="!is_subscribed ? 'text-blue-500' : ''"
                                      v-html="`€${billPlan == 'monthly' ? plans[0].price.monthly : plans[0].price.yearly}`"
                                      ></span>
                                <span class="text-gray-400" v-html="billPlan == 'monthly' ? '/month' : '/year'"></span>
                              </div>

                              <!--  -->
                              <div class="flex-shrink-0 pb-6 space-y-2 border-b mt-2">
                                <h2 class="text-2xl font-normal">Free</h2>
                                <p class="text-sm text-gray-400">{{ plans[0].short_description }}</p>
                              </div>


                        </th>
                        <th class="pspacer"></th>
                        <th class="pcol p-5 bg-white rounded-t-md text-left relative">

                            <div class="flex-shrink-0 mt-5">
                                <span
                                      class="text-4xl font-medium tracking-tight"
                                      :class="is_pro_plan ? 'text-blue-500' : ''"
                                      v-html="`€${billPlan == 'monthly' ? plans[1].price.monthly : plans[1].price.yearly}`"
                                      ></span>
                                <span class="text-gray-400" v-html="billPlan == 'monthly' ? '/month' : '/year'"></span>
                              </div>

                              <div class="flex-shrink-0 pb-6 space-y-2 border-b mt-2">
                                <h2 class="text-2xl font-normal">Pro</h2>
                                <p class="text-sm text-gray-400">{{ plans[1].short_description }}</p>
                              </div>
                              <transition name="fade">
                              <div v-if="billPlan=='yearly'"
                                class="absolute w-full top-0 left-0 text-center p-1 bg-blue-400 text-white text-sm font-normal rounded-t-md">{{ plans[1].yearly_incentive }}</div>
                              </transition>

                        </th>
                        <th class="pspacer"></th>
                        <th class="pcol p-5 bg-white rounded-t-md text-left relative">

                            <div class="flex-shrink-0 mt-5" v-if="has_enterprise_access">
                            <span
                                  class="text-4xl font-medium tracking-tight"
                                  :class="is_enterprise_plan ? 'text-blue-500' : ''"
                                  v-html="`€${billPlan == 'monthly' ? plans[2].price.monthly : plans[2].price.yearly}`"
                                  ></span>
                            <span class="text-gray-400" v-html="billPlan == 'monthly' ? '/month' : '/year'"></span>
                          </div>
                            <div class="flex-shrink-0 mt-3 mb-5" v-else>
                                <span class="text-sm font-bold tracking-tight"><a class="hover:underline text-blue-600" :href="'mailto:hey@'+domain" title="Get a price estimate">Get a price estimate</a></span>
                            </div>

                            <div class="flex-shrink-0 pb-6 space-y-2 border-b mt-2">
                                <h2 class="text-2xl font-normal">Enterprise</h2>
                                <p class="text-sm text-gray-400" v-if="has_enterprise_access">{{ plans[2].short_description }}</p>
                                <p class="text-sm text-gray-400" v-else>Unlimited recordings and tailored solutions for growing support teams</p>
                            </div>
                            <transition name="fade">
                            <div v-if="billPlan=='yearly' && has_enterprise_access"
                                class="absolute w-full top-0 left-0 text-center p-1 bg-blue-400 text-white text-sm font-normal rounded-t-md">{{ plans[2].yearly_incentive }}</div>
                            </transition>

                        </th>
                        <th class="pspacer"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="">
                        <td class="rounded-l-md"></td>
                        <td class="p-5">Seats</td>
                        <td></td>
                        <td class="p-5 bg-white flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Up to 3 seats</td>
                        <td></td>
                        <td class="p-5 bg-white flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Up to 10 seats</td>
                        <td></td>
                        <td class="p-5 bg-white flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Unlimited</td>
                        <td class="rounded-r-md"></td>
                    </tr>
                    <tr class="">
                        <td class="rounded-l-md"></td>
                        <td class="p-5 ">Incoming recordings</td>
                        <td></td>
                        <td class="p-5 bg-white flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Up to 10/month</td>
                        <td></td>
                        <td class="p-5 bg-white flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Unlimited</td>
                        <td></td>
                        <td class="p-5 bg-white flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Unlimited</td>
                        <td class="rounded-r-md"></td>
                    </tr>
                    <tr class="">
                        <td class="rounded-l-md"></td>
                        <td class="p-5">Data retention</td>
                        <td></td>
                        <td class="p-5 bg-white flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> 1 month</td>
                        <td></td>
                        <td class="p-5 bg-white flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Unlimited</td>
                        <td></td>
                        <td class="p-5 bg-white flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Unlimited</td>
                        <td class="rounded-r-md"></td>
                    </tr>

                    <tr class="">
                          <td class="rounded-l-md hidden md:table-cell"></td>
                          <td class="p-5 hidden md:table-cell">{{ app_name }} for your helpdesk</td>
                          <td class="hidden md:table-cell"></td>
                          <td class="p-5 bg-white md:flex items-start ">
                              Zendesk, Intercom, Freshchat, Helpscout</td>
                          <td class=" hidden md:table-cell"></td>
                          <td class="p-5 bg-white md:flex items-start ">
                              Zendesk, Intercom, Freshchat, Helpscout</td>
                            <td class=" hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start ">
                                Zendesk, Intercom, Freshchat, Helpscout</td>
                          <td class="rounded-r-md hidden md:table-cell"></td>
                      </tr>
                      <tr class="">
                          <td class="rounded-l-md hidden md:table-cell"></td>
                          <td class="p-5 hidden md:table-cell">Other integrations</td>
                          <td class="hidden md:table-cell"></td>
                          <td class="p-5 bg-white md:flex items-start ">
                              Slack, Zapier</td>
                          <td class=" hidden md:table-cell"></td>
                          <td class="p-5 bg-white md:flex items-start ">
                              Slack, Zapier</td>
                            <td class=" hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start ">
                                Slack, Zapier</td>
                          <td class="rounded-r-md hidden md:table-cell"></td>
                      </tr>
                      <tr class="">
                          <td class="rounded-l-md hidden md:table-cell"></td>
                          <td class="p-5 hidden md:table-cell">{{ app_name }} in-app
                          </td>
                          <td class="hidden md:table-cell"></td>
                          <td class="p-5 bg-white md:flex items-start items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="hidden md:block text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Included</td>
                          <td class=" hidden md:table-cell"></td>
                          <td class="p-5 bg-white md:flex items-start items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="hidden md:block text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Included</td>
                            <td class=" hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="hidden md:block text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Included</td>
                          <td class="rounded-r-md hidden md:table-cell"></td>
                      </tr>
                      <tr class="">
                          <td class="rounded-l-md hidden md:table-cell"></td>
                          <td class="p-5 hidden md:table-cell">Customizable recorder</td>
                          <td class="hidden md:table-cell"></td>
                          <td class="p-5 bg-white md:flex items-start items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="hidden md:block text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Included</td>
                          <td class=" hidden md:table-cell"></td>
                          <td class="p-5 bg-white md:flex items-start items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="hidden md:block text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Included</td>
                            <td class=" hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="hidden md:block text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Included</td>
                          <td class="rounded-r-md hidden md:table-cell"></td>
                      </tr>

                      <tr class="">
                        <td class="rounded-l-md hidden md:table-cell"></td>
                        <td class="p-5 hidden md:table-cell"><div class="flex items-center gap-x-2">AI summary <InformationCircleIcon class="w-4 h-4" v-tippy="{content:'Save time by getting a summary of the recording'}" /></div>
                        </td>
                        <td class="hidden md:table-cell"></td>
                        <td class="p-5 bg-white md:flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Not included</td>
                        <td class=" hidden md:table-cell"></td>
                        <td class="p-5 bg-white md:flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Not included</td>
                          <td class=" hidden md:table-cell"></td>
                          <td class="p-5 bg-white md:flex items-start items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="hidden md:block text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Included</td>
                        <td class="rounded-r-md hidden md:table-cell"></td>
                      </tr>


                      

                      <tr class="">
                        <td class="rounded-l-md hidden md:table-cell"></td>
                        <td class="p-5 hidden md:table-cell">Console logs
                        </td>
                        <td class="hidden md:table-cell"></td>
                        <td class="p-5 bg-white md:flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Not included</td>
                        <td class=" hidden md:table-cell"></td>
                        <td class="p-5 bg-white md:flex items-start items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Not included</td>
                          <td class=" hidden md:table-cell"></td>
                          <td class="p-5 bg-white md:flex items-start items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="hidden md:block text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Included</td>
                        <td class="rounded-r-md hidden md:table-cell"></td>
                      </tr>

                        <tr class="">
                            <td class="rounded-l-md hidden md:table-cell"></td>
                            <td class="p-5 hidden md:table-cell">Auto-deletion
                            </td>
                            <td class="hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Not included</td>
                            <td class=" hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Not included</td>
                            <td class=" hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="hidden md:block text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Included</td>
                            <td class="rounded-r-md hidden md:table-cell"></td>
                        </tr>

                        <tr class="">
                            <td class="rounded-l-md hidden md:table-cell"></td>
                            <td class="p-5 hidden md:table-cell">Blur sensitive data
                            </td>
                            <td class="hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Not included</td>
                            <td class=" hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Not included</td>
                            <td class=" hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="hidden md:block text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Included</td>
                            <td class="rounded-r-md hidden md:table-cell"></td>
                        </tr>
                        <tr class="">
                            <td class="rounded-l-md hidden md:table-cell"></td>
                            <td class="p-5 hidden md:table-cell">Support</td>
                            <td class="hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Standard</td>
                            <td class=" hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-300 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Standard</td>
                            <td class=" hidden md:table-cell"></td>
                            <td class="p-5 bg-white md:flex items-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="hidden md:block text-green-400 w-5 h-5 mr-2"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> Dedicated CSM</td>
                            <td class="rounded-r-md hidden md:table-cell"></td>
                        </tr>
                    </tbody>
                    <tfoot>
                    <tr class="">
                        <td class="rounded-l-md"></td>
                        <td class="p-5"></td>
                        <td></td>
                        <td class="p-5 bg-white rounded-b-md">
                            <jet-button class="w-full" v-if="is_subscribed"
                                @click="gotoBilling('free')">
                                    <span class="hidden md:inline"> Switch to Free</span>
                            </jet-button>
                            <jet-secondary-button v-else
                                class="w-full justify-center cursor-default text-blue-800 border-blue-800 hover:text-blue-800" disabled
                                @click.prevent>
                                    <vue-feather type="check" class="w-4 h-4 mr-2" />
                                    <span class="hidden md:inline">Current Plan</span>
                            </jet-secondary-button>
                        </td>
                        <td></td>
                        <td class="p-5 bg-white rounded-b-md">
                            <jet-button v-if="is_pro_plan && billPlan == 'monthly' && current_frequency == 'yearly'"
                                class="w-full"
                                @click="gotoBilling('pro')">
                                    <span class="hidden md:inline"> Switch to Monthly</span>
                            </jet-button>
                            <jet-button v-else-if="is_pro_plan && billPlan == 'yearly' && current_frequency == 'monthly'"
                                class="w-full"
                                @click="gotoBilling('pro')">
                                    <span class="hidden md:inline"> Switch to Annual</span>
                            </jet-button>
                            <jet-button v-else-if="is_enterprise_plan"
                                class="w-full"
                                @click="gotoBilling('pro')">
                                    <span class="hidden md:inline"> Downgrade to Pro</span>
                            </jet-button>
                            <jet-button v-else-if="!is_pro_plan"
                                class="w-full"
                                @click="gotoBilling('pro')">
                                    <span class="hidden md:inline"> Upgrade to Pro</span>
                            </jet-button>
                            <jet-secondary-button v-else
                                class="w-full 
                                cursor-default justify-center text-blue-800 border-blue-800 hover:text-blue-800" disabled
                                @click.prevent>
                                    <vue-feather type="check" class="w-4 h-4 mr-2" />
                                    <span class="hidden md:inline">Current Plan</span>
                            </jet-secondary-button>
                        </td>
                        <td></td>

                        <td class="p-5 bg-white rounded-b-md" v-if="has_enterprise_access">
                            <jet-button v-if="is_enterprise_plan && billPlan == 'monthly' && current_frequency == 'yearly'"
                                class="w-full"
                                @click="gotoBilling('enterprise')">
                                    <span class="hidden md:inline"> Switch to Monthly</span>
                            </jet-button>
                            <jet-button v-else-if="is_enterprise_plan && billPlan == 'yearly' && current_frequency == 'monthly'"
                                class="w-full"
                                @click="gotoBilling('enterprise')">
                                    <span class="hidden md:inline"> Switch to Annual</span>
                            </jet-button>
                            <jet-button v-else-if="!is_enterprise_plan"
                                class="w-full"
                                @click="gotoBilling('enterprise')">
                                    <span class="hidden md:inline"> Upgrade to Enterprise</span>
                            </jet-button>
                            <jet-secondary-button v-else
                                class="w-full justify-center cursor-default text-blue-800 border-blue-800 hover:text-blue-800" disabled
                                @click.prevent>
                                    <vue-feather type="check" class="w-4 h-4 mr-2" />
                                    <span class="hidden md:inline">Current Plan</span>
                            </jet-secondary-button>
                        </td>

                        <td class="p-5 bg-white rounded-b-md" v-else>
                            <jet-button-link class="w-full"
                                :href="'mailto:hey@'+domain">
                                    <span class="hidden md:inline mx-auto"> Contact Sales</span>
                            </jet-button-link>

                        </td>
                        <td class="rounded-r-md"></td>
                    </tr>
                    </tfoot>
                </table>




                <div class="mx-auto w-full max-w-5xl mt-8">

                    <jet-section-border />

                    <div class="flex flex-col justify-center px-4">
                        <p class="text-center font-bold text-gray-800 text-lg mb-5">Frequently Asked Questions</p>
                        <list-toggle>
                            <template #title>
                               Is tax included in all the prices?
                            </template>
                            <template #content>
                                <div class="rounded-xl p-5 bg-gray-100">
                                <p>It isn't. Additional taxes may apply depending on your country.</p>
                                </div>
                            </template>
                        </list-toggle>

                    </div>

                </div>


                </main>

























            </div>

        </div>

    </div>

</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import JetButton from '@/Jetstream/Button'
    import JetButtonLink from '@/Jetstream/ButtonLink'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton'
    import JetSectionBorder from '@/Jetstream/SectionBorder'
    import ListToggle from '@/Components/UI/ListToggle'
    import { InformationCircleIcon } from "@heroicons/vue/20/solid";


    export default {
        props: ["the_plans", "current_frequency", "current_plan_id",
            "current_plan_name", "has_enterprise_access"],
        components: {
            AppLayout,JetButton,JetSecondaryButton,
            JetSectionBorder, ListToggle, JetButtonLink, InformationCircleIcon
        },
        layout: AppLayout, // keep layout in place avoid refreshing it
        data() {
            return {
                billPlan: this.current_frequency || "monthly",
                plans: this.the_plans,
                domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
                app_name: this.$page.props.app_name
            }
        },
        computed: {
            is_subscribed() {
                return this.current_plan_id != ""
            },
            is_free_plan() {
                return this.current_plan_id == ""
            },
            is_pro_plan() {
                return this.current_plan_name.substr(0, 3) == "Pro"
            },
            is_enterprise_plan() {
                return this.current_plan_name.substr(0, 10) == "Enterprise"
            }
        },
        created() {

            // this.EventBus.on("start.call", function(toto) {
            //     this.test(toto)
            // }.bind(this));
        },
        beforeUnmount() {
            // this.EventBus.off("start.call", this.test);
        },
        mounted() {
            //console.log(this.plans)
            // this.EventBus.emit("start.call", "hello")
        },
        methods: {
            gotoBilling(type) {
                
                var url = "/billing"
                
                if (this.is_subscribed) {
                    window.location.href = url
                    return
                }

                //var url = "/billing"
                if (type == 'free') {
                    // axios.put('/spark/subscription/cancel')
                    // .then(response => {
                    //   console.log(response)
                    // })
                    // .catch(e => {
                    //   console.error(e);
                    // });
                } else {
                    var planIndex = 1;
                    if (type == "pro") {
                        planIndex = 1;
                    } else if (type == "enterprise") {
                        planIndex = 2;
                    }
                    if (this.billPlan == "monthly") {
                        url += "?subscribe=" + this.plans[planIndex]["monthly_id"]
                    } else if (this.billPlan == "yearly") {
                        url += "?subscribe=" + this.plans[planIndex]["yearly_id"]
                    }
                }
                window.location.href = url
            }
        }
    }
</script>

<style scoped>
.fade-enter {
    opacity: 0;
}
.fade-enter-active {
    transition: all 0.2s ease-out;
}
.fade-leave-to {
    opacity: 0;
}
.fade-leave-active {
    transition: all 0.2s ease-in;
}
    table tbody tr:hover td {
        /* -webkit-transition: background-color 200ms ease-in-out;
        -ms-transition: background-color 200ms ease-in-out;
        transition: background-color 200ms ease-in-out; */
    }
    table tbody tr:hover td {
        background: #DBEAFE;
    }
    th.pspacer {
      width: 2%;
  }
  th.plabel {
      width: 24%;
  }
  th.pcol {
      width: 22%;
  }
</style>
